module.exports = __webpack_public_path__ + "img/1.1275ac29.jpg";